/**
 * Created by hyr111276 on 2018/1/11.
 */
import {EventBus} from './event-bus';
import toast from './toast';
import Locate from './Locate';

const locate = new Locate();

export default function (aosUrl, errorCode) {
  switch (errorCode * 1) {
    case 102:
      EventBus.$emit('activity.status.notBegin');
      break;
    case 103:
      EventBus.$emit('activity.status.ended');
      break;
    case 1002:
      toast('验证码错误');
      break;
    case 150:
      toast('手机号状态异常');
      break;
    case -10:
      toast('亲的网络不太好哦, 请检查后重试');
      break;
    case -1:
    case -2:
      // locate.pageError(aosUrl, errorCode);
      break;
    default:
      // locate.pageError(aosUrl, errorCode);
      // toast('网络异常，请刷新页面');
  }
}